import React from "react";
import axios from "axios";
import styled from "styled-components";
import BackgroundImage from "../../../components/BackgroundImage";
import Glassmorphism from "../../../components/Glassmorphism";
import LogoImage from "../../../components/LogoImage";
import Text from "../../../../../_components/Text";
import { toast, ToastContainer } from "react-toastify";

import { getConfig } from "../../../../../utils/config";
import { setCookieByName } from "../../../../../utils";

const config = getConfig();

const URL_ACCESS_TOKEN_NAME = "access_token";

const SingleSignOnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  height: 100%;

  i{
    text-align: center;
  }
  @media (max-width: 768px) {
    margin-bottom: 30px;
`;

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  const ref = React.useRef(null);

  async function authenticateWithToken(token) {
    const apiUrl = `${config.api.baseUrl}/api/v1/users/sso-auth/`;

    axios
      .post(apiUrl, { token: token })
      .then((resp) => {
        setCookieByName("access", resp.data.access);
        setCookieByName("refresh", resp.data.refresh);
        window.localStorage.setItem("easygestorweb_apikey", resp.data.access);
        window.localStorage.setItem(
          "easygestorweb_refresh_token",
          resp.data.refresh
        );
        setCookieByName("username", resp.data.user_name);
        window.localStorage.setItem(
          "easygestorweb_userdata",
          JSON.stringify({
            name: resp.data.user_name,
            email: resp.data.user_email,
            id: resp.data.user_id,
          })
        );

        setCookieByName("branch_owner_name", resp.data.branch.name);
        setCookieByName("branch_owner_id", resp.data.branch.id);
        setCookieByName("branch_state_name", resp.data.branch.address.state);

        window.localStorage.setItem(
          "easygestorweb_current_branch",
          JSON.stringify(resp.data.branch)
        );
        window.location.href = "/";
      })
      .catch((error) => {
        if (error.response.data === "invalid-credential") {
          toast.error(<Text color="white">Token inválido</Text>, {
            toastId: "sso-token-invalid",
          });
        } else if (error.response.data.invalid_cnpj) {
          toast.error(<Text color="white">CNPJ inválido</Text>, {
            toastId: "sso-cnpj-invalid",
          });
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 5000);
      });
  }

  React.useEffect(() => {
    setLoading(true);
    const qs = new URLSearchParams(location.search);
    const token = qs.get(URL_ACCESS_TOKEN_NAME);

    if (!token) {
      toast.error(<Text color="white">Token inválido</Text>, {
        toastId: "sso-token-not-found",
      });

      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } else {
      authenticateWithToken(token);
    }
  }, [ref.current]);

  return (
    <BackgroundImage ref={ref}>
      <div className="container">
        <Glassmorphism>
          <div className="row">
            <SingleSignOnContainer>
              <div className="">
                <LogoImage
                  className="py-3"
                  src="https://content.easygestor.com/easygestor/logo_easygestor.png"
                  alt="Easygestor web logo image"
                />
                <Text as="h2" className="mb-3">
                  Bem-vindo(a) ao Easygestor Web!
                </Text>
                <Text>
                  O EasyGestor online é um Sistema de Gestão, voltado para micro
                  e pequenas empresas, 100% ausente de instalação, e com um
                  armazenamento gerenciado com tecnologia em nuvem. Para
                  mantermos o EasyGestor, algumas soluções específicas como,
                  emissão de NFe e NFCe, Controle de Estoque, Relatório de
                  Vendas, etc, serão cobradas, através de uma assinatura mensal
                  de acordo com a sua necessidade. Mas não se preocupe, nenhum
                  pagamento será feito sem a sua autorização prévia.
                </Text>
              </div>
            </SingleSignOnContainer>

            <div className={loading ? "w-100" : "d-none"}>
              <Text align="center" className="mb-3">
                <i className="fas fa-spinner fa-pulse fa-3x"></i>
              </Text>
            </div>
          </div>
          <ToastContainer position="top-center" />
        </Glassmorphism>
      </div>
    </BackgroundImage>
  );
};



// WEBPACK FOOTER //
// ./src/views/Auth/Login/components/sso/index.jsx